class CustomiserAssemble extends HTMLElement {
  constructor() {
    super()

    this.basket = {
      enable: false,
      size: null,
    }

    this.b2b = false

    this.carabiner_required = false

    this.selection = {
      color: null,
      ropes: null,
      carabiner: null,
      totalPrice: 0,
    }

    this.ui = {
      // wrapper: this.querySelector('.customiser-assemble__form'),
      price: this.querySelector('.customiser-assemble__price'),
      bagSelection: this.querySelector('.customiser-assemble__bag'),
      button: this.querySelector('.customiser-assemble__button button'),
      coloursSelectForm: this.querySelector('customiser-select[data-step="color"]').querySelector(
        'form'
      ),
      footer: this.querySelector('.customiser-assemble__footer'),
      rows: this.querySelectorAll('customiser-select'),
    }

    this.endCustomiser = this.endCustomiser.bind(this)
  }

  async connectedCallback() {
    gsap.set(['.customiser-select__next-step'], { autoAlpha: 0 })
    // this.getBagProducts()
    if (window.scrollY > 0) {
      gsap.to(window, { duration: 0.2, scrollTo: { y: 0 } })
    }

    if (window.spark) {
      this.b2b = await window.spark.isLoggedIn()
    }

    this.ui.button.addEventListener('click', this.endCustomiser)
  }

  disconnectedCallback() {
    this.ui.button.removeEventListener('click', this.endCustomiser)
  }

  endCustomiser() {
    const notComplete = this.checkAllRequiredModules()
    if (notComplete) {
      return
    }

    this.parentElement.showEndScreen()
  }

  setShapeSelection(title) {
    this.ui.bagSelection.innerText = title
  }

  setSelection(step, target) {
    this.selection[step] =
      target == null
        ? null
        : {
            handle: target.dataset.variant ? target.dataset.product : target.value,
            productId: target.dataset.productId,
            variantSKU: target.dataset.variantSku,
            id: target.dataset.variant ? target.dataset.variant : 'no-id',
            title: target.dataset.title,
            price: target.dataset.price,
            image: target.dataset.image,
          }

    if (step == 'color' && target) {
      this.selection[step].basket = target.dataset.basket
    }

    this.updatePrice()

    if (step == 'color' && target) {
      this.disablePurchase('enable') // do auto check
    }

    if (step == 'carabiner') {
      if (this.carabiner_required) {
        this.disablePurchase(this.selection.carabiner ? 'enable' : 'disable')
      } else {
        this.disablePurchase('enable')
      }
    }
  }

  async updatePrice() {
    const allProducts = Object.values(this.selection)
    let price = 0

    const pricePromises = allProducts.map(async product => {
      if (product && product.price) {
        const productPrice = await this.getPrice(product)
        return productPrice // Return the price for the Promise.all
      }
      return 0 // Return 0 for products without a price
    })

    const allPrices = await Promise.all(pricePromises)

    // Sum up all the prices
    price = allPrices.reduce((total, currentPrice) => total + currentPrice, 0)

    this.selection.totalPrice = parseFloat(price.toFixed(2))
    this.ui.price.innerText = '€' + this.selection.totalPrice
  }

  async getPrice(product) {
    let price = product
    if (this.b2b) {
      // get price for b2b clients
      const b2bPrice = await window.spark.getPricingForVariant(
        product.productId,
        product.variantSKU
      )
      price = b2bPrice.price
    } else {
      price = product.price / 100
      price = parseFloat(price.toFixed(2))
    }

    return price
  }

  disablePurchase(state) {
    const disable = state == 'disable'
    if (!disable) {
      // check if all required modules are here
      this.ui.button.disabled = this.checkAllRequiredModules()
    } else {
      this.ui.button.disabled = true
    }
  }

  checkAllRequiredModules() {
    const requiredModules = ['color', 'ropes']
    if (this.carabiner_required) {
      requiredModules.push('carabiner')
    }

    const allModules = Object.keys(this.selection)
    const missingModules = requiredModules.filter(
      module => !allModules.includes(module) || !this.selection[module]
    )

    // returns true or false
    return missingModules.length > 0
  }

  animateIn() {
    return gsap
      .timeline({
        paused: true,
      })
      .to(window, { scrollTo: { y: 0, duration: 0.2 } })
      .from(['.customiser-select__next-step'], { opacity: 0, duration: 0.2, clearProps: 'all' }, 0)
      .fromTo(['.customiser-select__inner'], { autoAlpha: 0 }, { autoAlpha: 1 }, 0)
      .to(this.ui.footer, { y: 0, autoAlpha: 1, duration: 0.2, ease: 'power2.out' })
      .restart()
  }

  animateOut() {
    const timeline = gsap
      .timeline({ paused: true })
      .to(['.customiser-select__inner', '.customiser-select__next-step'], {
        autoAlpha: 0,
        duration: 0.2,
        stagger: 0.1,
      })
      .to(this.ui.footer, { autoAlpha: 0, duration: 0.2, ease: 'power2.out' })
    this.parentElement.setSelection(this.selection, this.carabiner_required, this.b2b)
    return timeline.restart()
  }
}

class CustomiserSelect extends HTMLElement {
  constructor() {
    super()

    this.step = this.dataset.step
    this.selected = null

    this.ui = {
      form: this.querySelector('form'),
      inner: this.querySelector('.customiser-select__inner'),
      parent: document.querySelector('customiser-assemble'),
      label: this.querySelector('.customiser-select__next-step'),
      next: null,
    }

    this.label = {
      element: this.ui.label,
      default: this.ui.label.innerText,
    }

    this.initiated = this.step === 'bags'
    this.active = false

    this.onChange = this.onChange.bind(this)
  }

  connectedCallback() {
    this.setScrollCenter()
    this.ui.form.addEventListener('change', this.onChange)

    // this.ui.next =
    requestAnimationFrame(() => {
      if (this.step == 'bags') {
        this.setActive()
      }
    })
  }

  disconnectedCallback() {
    this.ui.form.removeEventListener('change', this.onChange)
  }

  setScrollCenter() {
    const items = this.querySelectorAll('.customiser-select__inner__wrapper .item')

    if (items && items.length > 0) {
      const allItems = Array.from(items)
      const centerElement = this.getMiddleElement(allItems)

      this.setSelectedElementCentral(centerElement)
    }
  }

  getMiddleElement(array) {
    const middleIndex = Math.floor(array.length / 2)
    if (array.length % 2 !== 0) {
      return array[middleIndex]
    }
    return array[middleIndex - 1]
  }

  async onChange(e) {
    const label = this.querySelector(`label[for="${e.target.id}"]`)
    this.setSelectedElementCentral(label)

    if (this.step == 'ropes') {
      // check if carabiner is required
      const carabiner_required = e.target.dataset.carabiner == 'true'
      this.parentElement.carabiner_required = carabiner_required

      this.selected = e.target.value
      this.ui.parent.setSelection(this.step, e.target)
      this.handleRopeSelection(carabiner_required)
      return
    }

    if (!this.selected) {
      this.enableNextRow(e.target.value)
    }

    if (this.step == 'bags') {
      if (!this.selected) {
        this.enableNextRow(e.target.value)
      } else {
        await this.filterColorVariants(e.target.value)
        this.resetNextSiblinForm()
        this.ui.parent.setSelection('color', null)
        this.ui.parent.disablePurchase('disable')

        // on next frame
        requestAnimationFrame(() => {
          this.setSelectedElementCentral(label)
        })
      }
      this.ui.parent.setShapeSelection(e.target.dataset.title)
    }

    this.selected = e.target.value

    if (this.step !== 'bags' && this.step !== 'end') {
      this.ui.parent.setSelection(this.step, e.target)
    }

    if (this.step == 'carabiner' && this.selected) {
      this.scrollIntoView(0)
    }
  }

  setSelectedElementCentral(target) {
    const offsetX = (window.innerWidth - target.clientWidth) / 2
    gsap.to(this.ui.inner, {
      duration: 0.5,
      scrollTo: { x: target, offsetX: offsetX },
    })
  }

  setInactive() {
    this.active = false
    this.classList.remove('--active')

    this.nextElementSibling.classList.remove('--initiated')
  }

  setInitiated() {
    this.initiated = true
    this.classList.add('--initiated')
  }

  setActive() {
    this.active = true
    this.classList.remove('--initiated')
    this.classList.add('--active')

    if (this.nextElementSibling) {
      this.nextElementSibling.setInitiated()
    }
  }

  handleRopeSelection(carabiner_required) {
    if (this.ui.parent.carabiner_required && carabiner_required) {
      return
    }

    this.ui.parent.carabiner_required = carabiner_required
    // first time selecting rope
    // next element is not yet active - check if it needs to be activated depending on carabiner_required
    if (!this.nextElementSibling.active) {
      if (carabiner_required) {
        this.nextElementSibling.setActive()
        this.ui.parent.disablePurchase('disable')
        this.scrollIntoView('max')
      } else {
        this.nextElementSibling.setInactive()
        this.ui.parent.disablePurchase('enable')
        this.nextElementSibling.changeLabelToComplete(true)
        this.scrollIntoView(0)
      }
    } else {
      // changing rope but coming from carabiner_required false = carabiner needs to be activated
      // changing rope but coming from carabiner_required true = carabiner needs to be deactivated
      if (carabiner_required) {
        this.nextElementSibling.setActive()
        this.ui.parent.disablePurchase('disable')
        this.nextElementSibling.changeLabelToComplete(false)
        this.scrollIntoView('max')
      } else {
        this.nextElementSibling.setInactive()
        this.ui.parent.setSelection('carabiner', null)
        this.ui.parent.disablePurchase('enable')
        this.resetNextSiblinForm()
        this.scrollIntoView(0)

        this.nextElementSibling.changeLabelToComplete(true)
      }
    }

    // window.scrollY == 0 && this.scrollIntoView('max')
  }

  changeLabelToComplete(state = true) {
    this.label.element.innerText = state ? 'No carabiner needed' : this.label.default
    this.nextElementSibling.classList.toggle('--complete', state)
    this.scrollIntoView(0)
  }

  filterOnBagType(handle, elementType = 'input') {
    // set everything to display none
    const allElements = Array.from(this.nextElementSibling.querySelectorAll(elementType))
    const productVariants = allElements.filter(element => element.dataset.product == handle)

    return gsap
      .timeline()
      .set(allElements, { display: 'none' }, 0)
      .set(productVariants, { display: 'block' })
    // .to(window, { y: duration: 0.1 })
  }

  async filterColorVariants(handle) {
    await this.filterOnBagType(handle, 'input')
    await this.filterOnBagType(handle, 'label')

    return true
    // this.nextElementSibling.querySelectorAll('input').forEach(input => {})
  }

  resetNextSiblinForm() {
    this.nextElementSibling.querySelector('form').reset()
  }

  async enableNextRow(handle) {
    if (this.step == 'bags') {
      await this.filterColorVariants(handle)
    }

    if (this.step == 'color') {
      this.scrollIntoView('max')
    }

    if (this.step == 'carabiner') {
      this.scrollIntoView(0)
      this.ui.parent.disablePurchase('enable')
    }

    this.nextElementSibling.setActive()
  }

  scrollIntoView(position = 'max') {
    gsap.to(window, { duration: 0.5, scrollTo: { y: position } })
  }
}

if (!customElements.get('customiser-assemble')) {
  customElements.define('customiser-assemble', CustomiserAssemble)
}

if (!customElements.get('customiser-select')) {
  customElements.define('customiser-select', CustomiserSelect)
}
